import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=49435a80&scoped=true&"
import script from "./CompanyDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDetails.vue?vue&type=script&lang=js&"
import style1 from "@/assets/css/form.css?vue&type=style&index=1&id=49435a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49435a80",
  null
  
)

export default component.exports